import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-select-date-modal',
  templateUrl: './select-date-modal.component.html',
  styleUrls: ['./select-date-modal.component.scss'],
  standalone: false
})
export class SelectDateModalComponent implements OnInit {
  @Input() name = 'dateInput';
  @Input() dateValue: Date;
  @Input() presentation = 'date-time';
  @Output() dateValueChange = new EventEmitter<Date>();
  dataOriginale: Date;
  dataCalendar = '';

  constructor() { }

  ngOnInit() {
    const initial = this.toValidDate(this.dateValue);
    this.dateValue = initial;
    this.dataOriginale = new Date(initial.getTime());
    // ion-datetime gestisce valori in formato datetime-local.
    // Evitiamo toISOString() (UTC) per non introdurre shift orari in visualizzazione.
    this.dataCalendar = this.toLocalDateTimeValue(initial);
  }

  changeDate = () => {
    const parsed = this.fromDateTimeValue(this.dataCalendar);
    this.dateValue = parsed;
    this.dateValueChange.emit(new Date(parsed.getTime()));
  };

  private toValidDate(value: Date | string | null | undefined): Date {
    if (!value) return new Date();
    if (typeof value === 'string') {
      // ISO senza marker di timezone (es. "2026-05-28T10:41:00"): il backend
      // la invia in UTC ma il browser la interpreterebbe come locale.
      // Forziamo l'interpretazione UTC aggiungendo 'Z'.
      const hasTz = /[zZ]|[+-]\d{2}:?\d{2}$/.test(value);
      if (!hasTz && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(value)) {
        const parsed = new Date(value + 'Z');
        if (!Number.isNaN(parsed.getTime())) return parsed;
      }
    }
    const parsed = new Date(value as Date | string);
    return Number.isNaN(parsed.getTime()) ? new Date() : parsed;
  }

  private toLocalDateTimeValue(date: Date): string {
    const y = date.getFullYear();
    const m = this.pad2(date.getMonth() + 1);
    const d = this.pad2(date.getDate());
    const hh = this.pad2(date.getHours());
    const mm = this.pad2(date.getMinutes());
    const ss = this.pad2(date.getSeconds());
    return `${y}-${m}-${d}T${hh}:${mm}:${ss}`;
  }

  private fromDateTimeValue(value: string): Date {
    const raw = String(value ?? '').trim();
    if (!raw) return new Date();

    // Se arriva un ISO con timezone (es. ...Z o +02:00), delega al parser nativo.
    if (/[zZ]|[+-]\d{2}:\d{2}$/.test(raw)) {
      const parsed = new Date(raw);
      if (!Number.isNaN(parsed.getTime())) return parsed;
    }

    const [datePart, timePart = '00:00:00'] = raw.split('T');
    const [y, m, d] = datePart.split('-').map(Number);
    const [hh = 0, mm = 0, ss = 0] = timePart.split(':').map(Number);

    if ([y, m, d, hh, mm, ss].some(Number.isNaN)) {
      const fallback = new Date(raw);
      return Number.isNaN(fallback.getTime()) ? new Date() : fallback;
    }

    return new Date(y, m - 1, d, hh, mm, ss);
  }

  private pad2(value: number): string {
    return String(value).padStart(2, '0');
  }
}
